import {Alert, Button, Card, Table, Tag} from "antd";
import React, {useContext, useEffect, useState} from "react";
import Contacte from "../../../model/inscripcions/Contacte";
import {GetAutoritzatsInscripcionsId} from "../../../dao/inscripcions/GetAutoritzatsInscripcionsId";
import {ColumnsType, TableProps} from "antd/es/table";
import InscripcioContacte from "./InscripcioContacte";
import Colors from "../../../styles/Colors";
import {BiArrowBack, BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import {BsEye} from "react-icons/bs";
import AutoritzatModal from "./AutoritzatModal";
import {PostInscripcionsContacteSwitch} from "../../../dao/inscripcions/PostInscripcionsContacteSwitch";
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";

interface element {
    id_inscripcio: string,
    page: string,
    goBack: () => void,

}

const Autoritzats = (props: element) => {

    const [autoritzats, setAutoritzats] = useState<Contacte[]>([]);

    const [visible, setVisible] = useState(false);
    const [coleccio, setDades] = useState<Contacte[]>([]);
    const [loading, setLoading] = useState(false);

    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<Contacte>(new Contacte());

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const {id_inscripcio} = useParams();

    useEffect(() => {
        checkDades();
    }, []);

    const tableProps: TableProps<Contacte> = {
        loading
    };

    const onChange: TableProps<Contacte>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };


    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetAutoritzatsInscripcionsId(props.id_inscripcio + "", props.page);
        setAutoritzats(dades);
        await handleLoadingChange(false);
    }

    const expandedRowRender = (ele: Contacte) => {
        return (
            <InscripcioContacte element={ele}/>
        );
    };

    async function deleteElement(id: number) {
        //await DeleteIngredient(id, page);
        await checkDades();
    }

    function afegirElement(element: Contacte) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    function togleNouElement(element: Contacte) {
        setNouElement(!nouElement);
        setVisible(true);
        setElementSelected(element);
    }

    async function changeActiu(ele: Contacte) {
        handleLoadingChange(true)
        await PostInscripcionsContacteSwitch(id_inscripcio+"", page, ele);
        onClose();
    }

    const columns: ColumnsType<Contacte> = [
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            render: (estat, ele) => (
                <>{ele.nom}{" "}{ele.cognoms}</>
            ),
        },
        {
            key: 'dni',
            title: 'DNI',
            dataIndex: 'dni',
            width: 30,
        },
        {
            key: 'telefon1',
            title: 'Telèfons',
            dataIndex: 'telefon1',
            width: 30,
            render: (estat, ele) => (
                <>{ele.telefon}{" "}{ele.telefon2}{" "}{ele.telefon3}</>
            ),
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={ele.estat === 1 ? "success" : "warning"}>{ele.estat === 1 ? "ACTIU" : "NO ACTIU"}</Tag>
                </>
            ),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 50,
            render: (estat, ele) => (
                <>
                    <Button title={"Activar / Desactivar"} style={{backgroundColor: Colors.colors.color5}}
                            onClick={() => changeActiu(ele)}>{ele.estat === 1 ? "DESACTIVAR" : "ACTIVAR"}</Button>
                    {" "}
                    <Button title={"Modificar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele)}><BiPencil/></Button>
                </>
            ),
        },
    ];

    function onClose() {
        checkDades();
        setVisible(false);
    }

    return (
        <>
            <div className={"actionButtons"}>
                <Button title={"Sortir"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                    props.goBack()}><BiArrowBack/> SORTIR</Button>{" "}
                <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color5}} onClick={() =>
                    checkDades()}><BiRefresh/> REFRESCAR</Button>{" "}
                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}} onClick={() =>
                    afegirElement(new Contacte())}><BiPlus/> AFEGIR AUTORITZAT</Button>
            </div>
            <h4 className={"titol"}>{"AUTORITZATS"}</h4>
            <Card bordered={true} className={"elemento"}>
                <Alert type={"warning"} message={"Persones autoritzades a fer recollida dels infants apart dels introduits a PAGADORS"} />
                <div style={{overflowX: 'auto'}}>
                    <Table
                        {...tableProps}
                        onChange={onChange}
                        columns={columns}
                        //scroll={{ y: 240 }}
                        dataSource={autoritzats}
                    />
                </div>
            </Card>
            {visible && <AutoritzatModal element={elementSelected} visible={visible} onClose={onClose} idInsc={id_inscripcio+""} />}
        </>
    );

};

export default Autoritzats;